<template>
  <span>
    <span class="text" @click="showPrivacy">《服务条款及隐私政策》</span>

    <van-popup v-model="show.privacy" :style="{ height: '80%' }" :overlay-style="{background:'rgba(0,0,0,.3)'}" position="bottom" round>
      <div class="main-content">
        <h2 class="guidance">欢迎阅读优采服务条款协议 ( 下称“本协议” ) 。本协议阐述之条款和条件适用于您使用 youcaiyun.com 网站所提供的各种信息和服务 ( 下称“服务” ) 。 </h2>
        <ul>
          <li>
            <h2>1. 接受条款。</h2>
            <ul>
              <li>1.1 通过首页进入 youcaiyun.com 网站即表示您同意自己已经与优采公订立本协议，且您将受本协议的条款和条件 ( “条款” )
                约束。优采可随时自行全权决定更改“条款”。如“条款”有任何变更，优采将其网站上刊载公告，通知予您。如您不同意相关变更，必须停止使用“服务”。经修订的“条款”一经在优采网站的公布后，立即自动生效。您登录或继续使用“服务”将表示您接受经修订的“条款”。除另行明确声明外，任何使“服务”范围扩大或功能增强的新内容均受本协议约束。除非经优采的授权高层管理人员签订书面协议，本协议不得另行作出修订。
              </li>
              <li>
                1.2 用户必须同意接受优采通过电子邮件或其他方式向用户发送商品促销或其他相关商业信息。
              </li>
            </ul>
          </li>
          <li>
            <h2>2. 谁可使用 youcaiyun.com ？</h2>
            <ul>
              <li>
                “服务”仅供能够根据相关法律订立具有法律约束力的合约的个人或公司使用。因此，您的年龄必须在十八周岁或以上，才可使用本公司服务。如不符合本项条件，请勿使用“服务”。优采可随时自行全权决定拒绝向任何人士提供“服务”。“服务”不会提供给被暂时或永久中止资格的优采会员。
              </li>
            </ul>
          </li>
          <li>
            <h2>3. 收费。</h2>
            <ul>
              <li>本公司保留在根据第 1
                条通知您后，收取“服务”费用的权利。您因进行交易、向本公司获取有偿服务或接触本公司服务器而发生的所有应纳税赋，以及一切硬件、软件、服务及其他方面的费用均由您负责支付。本公司保留在无须发出通知的情况下，暂时或永久地更改或停止部份或全部“服务”的权利。
              </li>
            </ul>
          </li>
          <li>
            <h2>4. 您授予本公司的许可使用权。 </h2>
            <ul>
              <li>您授予本公司独家的、全球通用的、永久的、免费的许可使用权利 ( 并有权在多个层面对该权利进行再授权 ) ，使本公司有权 ( 全部或部份地 )
                使用、复制、修订、改写、发布、翻译、分发、执行和展示“您的资料”或制作其派生作品，和 / 或以现在已知或日后开发的任何形式、媒体或技术，将“您的资料”纳入其他作品内。
              </li>
            </ul>
          </li>
          <li>
            <h2>5. 隐私。 </h2>
            <ul>
              <li>优采将仅根据本公司的隐私声明使用“您的资料”。本公司隐私声明的全部条款属于本协议的一部份，因此，您必须仔细阅读。请注意，您一旦自愿地在优采交易地点披露“您的资料”，该等资料即可能被其他人士获取和使用。
              </li>
            </ul>
          </li>
          <li>
            <h2>6. 终止或访问限制。 </h2>
            <ul>
              <li>您同意，优采可自行全权决定以任何理由 ( 包括但不限于优采认为您已违反本协议的字面意义和精神，或以不符合本协议的字面意义和精神的方式行事，或您在超过 90 天的时间内未以您的帐号及密码登录网站 )
                终止您的“服务”密码、帐户 ( 或其任何部份 )
                或您对“服务”的使用，并删除和丢弃您在使用“服务”中提交的的“您的资料”。优采同时可自行全权决定，在发出通知或不发出通知的情况下，随时停止提供“服务”或其任何部份。您同意，根据本协议的任何规定终止您使用“服务”之措施可在不发出事先通知的情况下实施，并承认和同意，优采可立即使您的帐户无效，或撤销您的帐户以及在您的帐户内的所有相关资料和档案，和
                /
                或禁止您进一步接入该等档案或“服务”。帐号终止后，优采没有义务为您保留原帐号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，您同意，优采不会就终止您接入“服务”而对您或任何第三者承担任何责任。第
                8 、 9 、 10 和 18各条应在本协议终止后继续有效。
              </li>
            </ul>
          </li>
          <li>
            <h2>7. 违反规则会有什么后果？ </h2>
            <ul>
              <li>在不限制其他补救措施的前提下，发生下述任一情况，本公司可立即发出警告，暂时中止、永久中止或终止您的会员资格，删除您的任何现有产品信息，以及您在网站上展示的任何其他资料： (i) 您违反本协议； (ii)
                本公司无法核实或鉴定您向本公司提供的任何资料；或 (iii)
                本公司相信您的行为可能会使您、本公司用户或通过本公司或本公司网站提供服务的第三者服务供应商发生任何法律责任。在不限制任何其他补救措施的前提下，倘若发现您从事涉及本公司网站的诈骗活动，优采可暂停或终止您的帐户。
              </li>
            </ul>
          </li>
          <li>
            <h2>8. 服务“按现状”提供。 </h2>
            <ul>
              <li>
                本公司会尽一切努力使您在使用优采网站的过程中得到乐趣。遗憾的是，本公司不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用“服务”的风险由您自行承担。“服务”以“按现状”和“按可得到”的基础提供。优采明确声明不作出任何种类的所有明示或暗示的保证，包括但不限于关於适销性、适用於某一特定用途和无侵权行为等方面的保证。优采对下述内容不作保证：
                (i) “服务”会符合您的要求； (ii) “服务”不会中断，且适时、安全和不带任何错误； (iii) 通过使用“服务”而可能获取的结果将是准确或可信赖的；及 (iv)
                您通过“服务”而购买或获取的任何产品、服务、资料或其他材料的质量将符合您的预期。通过使用“服务”而下载或以其他形式获取任何材料是由您自行全权决定进行的，且与此有关的风险由您自行承担，对于因您下载任何该等材料而发生的您的电脑系统的任何损毁或任何数据损失，您将自行承担责任。您从优采或通过或从“服务”获取的任何口头或书面意见或资料，均不产生未在本协议内明确载明的任何保证。
              </li>
            </ul>
          </li>
          <li>
            <h2>9. 责任范围。 </h2>
            <ul>
              <li>您明确理解和同意，优采不对因下述任一情况而发生的任何损害赔偿承担责任，包括但不限於利润、商誉、使用、数据等方面的损失或其他无形损失的损害赔偿 ( 无论优采是否已被告知该等损害赔偿的可能性 ) ： (i)
                使用或未能使用“服务”； (ii) 因通过或从“服务”购买或获取任何货物、样品、数据、资料或服务，或通过或从“服务”接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用； (iii)
                未经批准接入或更改您的传输资料或数据； (iv) 任何第三者对“服务”的声明或关於“服务”的行为；或 (v) 因任何原因而引起的与“服务”有关的任何其他事宜，包括疏忽。
              </li>
            </ul>
          </li>
          <li>
            <h2>10. 赔偿。 </h2>
            <ul>
              <li>
                您同意，因您违反本协议或经在此提及而纳入本协议的其他文件，或因您违反了法律或侵害了第三方的权利，而使第三方对优采及其子公司、分公司、董事、职员、代理人提出索赔要求（包括司法费用和其他专业人士的费用），您必须赔偿给优采及其子公司、分公司、董事、职员、代理人，使其等免遭损失。
              </li>
            </ul>
          </li>
          <li>
            <h2>11. 遵守法律。 </h2>
            <ul>
              <li>您应遵守与您使用“服务”，以及与您竞买、购买和销售任何物品以及提供商贸信息有关的所有相关的法律、法规、条例和规章。</li>
            </ul>
          </li>
          <li>
            <h2>12. 无代理关系。 </h2>
            <ul>
              <li>您与优采仅为独立订约人关系。本协议无意结成或创设任何代理、合伙、合营、雇用与被雇用或特许权授予与被授予关系。</li>
            </ul>
          </li>
          <li>
            <h2>13. 广告和金融服务。 </h2>
            <ul>
              <li>
                您与在“服务”上或通过“服务”物色的刊登广告人士通讯或进行业务往来或参与其推广活动，包括就相关货物或服务付款和交付相关货物或服务，以及与该等业务往来相关的任何其他条款、条件、保证或声明，仅限于在您和该刊登广告人士之间发生。您同意，对于因任何该等业务往来或因在“服务”上出现该等刊登广告人士而发生的任何种类的任何损失或损毁，优采无需负责或承担任何责任。您如打算通过“服务”创设或参与与任何公司、股票行情、投资或证券有关的任何服务，或通过“服务”收取或要求与任何公司、股票行情、投资或证券有关的任何新闻信息、警戒性信息或其他资料，敬请注意，优采不会就通过“服务”传送的任何该等资料的准确性、有用性或可用性、可获利性负责或承担任何责任，且不会对根据该等资料而作出的任何交易或投资决策负责或承担任何责任。
              </li>
            </ul>
          </li>
          <li>
            <h2>14. 链接。 </h2>
            <ul>
              <li>
                “服务”或第三者均可提供与其他万维网网站或资源的链接。由于优采并不控制该等网站和资源，您承认并同意，优采并不对该等外在网站或资源的可用性负责，且不认可该等网站或资源上或可从该等网站或资源获取的任何内容、宣传、产品、服务或其他材料，也不对其等负责或承担任何责任。您进一步承认和同意，对于任何因使用或信赖从此类网站或资源上获取的此类内容、宣传、产品、服务或其他材料而造成（或声称造成）的任何直接或间接损失，优采均不承担责任。
              </li>
            </ul>
          </li>
          <li>
            <h2>15. 通知。 </h2>
            <ul>
              <li>除非另有明确规定，任何通知应以电子邮件形式发送， ( 就优采而言 ) 电子邮件地址为 service@youcaiyun.com ，或 ( 就您而言 )
                发送到您在登记过程中向优采提供的电子邮件地址，或有关方指明的该等其他地址。在电子邮件发出二十四 (24)
                小时后，通知应被视为已送达，除非发送人被告知相关电子邮件地址已作废。或者，本公司可通过邮资预付挂号邮件并要求回执的方式，将通知发到您在登记过程中向优采提供的地址。在该情况下，在付邮当日三 (3)
                天后通知被视为已送达。
              </li>
            </ul>
          </li>
          <li>
            <h2>16. 不可抗力。 </h2>
            <ul>
              <li>对于因本公司合理控制范围以外的原因，包括但不限於自然灾害、罢工或骚乱、物质短缺或定量配给、暴动、战争行为、政府行为、通讯或其他设施故障或严重伤亡事故等，致使本公司延迟或未能履约的，优采不对您承担任何责任。
              </li>
            </ul>
          </li>
          <li>
            <h2>17. 转让。 </h2>
            <ul>
              <li>优采转让本协议无需经您同意。</li>
            </ul>
          </li>
          <li>
            <h2>18. 其他规定。 </h2>
            <ul>
              <li>
                本协议构成您和优采之间的全部协议，规定了您对“服务”的使用，并取代您和优采先前订立的任何书面或口头协议。本协议各方面应受中华人民共和国大陆地区法律的管辖。倘若本协议任何规定被裁定为无效或不可强制执行，该项规定应被撤销，而其余规定应予执行。条款标题仅为方便参阅而设，并不以任何方式界定、限制、解释或描述该条款的范围或限度。本公司未就您或其他人士的某项违约行为采取行动，并不表明本公司撤回就任何继后或类似的违约事件采取行动的权利。
              </li>
            </ul>
          </li>
          <li>
            <h2>19. 仲裁。 </h2>
            <ul>
              <li>
                因本协议或本公司服务所引起或与其有关的任何争议应提交中国上海市仲裁委员会并根据其适用的仲裁规则进行仲裁裁决。任何该等争议应单独地仲裁，不得与任何其他方的争议在任何仲裁中合并处理。仲裁应在中国上海市进行，而仲裁裁决可提交对其有管辖权的任何法院予以强制执行。您或优采在仲裁进行期间，可向中国上海地区内具有管辖权的法院寻求为保护您或优采的权利或财产所需的任何临时或初步补救措施，包括但不限于财产保全或证据保全措施
                。
              </li>
            </ul>
          </li>
          <li>
            <h2>20. 权利的归属。 </h2>
            <ul>
              <li>20.1
                本网站用户原创的作品的一切版权、商标权、专利权、商业秘密等知识产权，以及与本信息相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，除涉及须经第三方授权的信息或技术外，本网站及作者共同享有版权，其他网站及传统媒体如需使用，须取得本网站的书面授权，未经授权严禁转载或用于其它商业用途。
              </li>
              <li>20.2 除了按本协议规定的方式行使本协议授予的权利之外，用户不得以其他任何方式行使本信息的其他权利。</li>
              <li>20.3 未明示授权的其他一切权利仍归本公司所有，用户使用其他权利时须另外取得本公司的书面同意。</li>
            </ul>
          </li>
          <li>
            <h2>21. 用户在遵守法律及本协议的前提下可依本协议使用本信息。用户无权实施包括但不限于下列行为： </h2>
            <ul>
              <li>21.1 用户通过非本公司开发、授权或认可的三方兼容信息、系统登录或使用本公司信息及服务，用户针对本公司公司的信息和服务使用非本公司公司开发、授权或认证的插件和外挂；</li>
              <li>21.2 删除本信息及其他副本上所有关于版权的信息、内容；除掉或掩盖有关信息著作权或商标的标志；</li>
              <li>21.3 对提供本信息的技术平台或软件进行反向工程、反向汇编、反向编译等；</li>
              <li>21.4 绕过该信息中的任何技术限制；</li>
              <li>21.5
                对于本信息，未经本公司书面同意，用户擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点、擅自借助本信息发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等。
              </li>
              <li> 21.6 利用本信息平台发表、传送、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定、公序良俗的内容，或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容。</li>
              <li>21.7 利用本信息平台发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容；</li>
              <li>21.8
                任何人进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本信息系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本信息系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
              </li>
              <li>21.9 不得通过修改或伪造信息平台运行中的指令、数据、数据包，增加、删减、变动信息的功能或运行效果；</li>
              <li>21.10 在未经本公司公司书面明确授权前提下，出售、出租、出借、散布、转移或转授权信息和服务或相关的链接或从使用信息和服务或信息和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；</li>
              <li>21.11 其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本信息和和本公司提供的其他服务；</li>
              <li>21.12 用户若违反上述规定，本公司有权采取终止、完全或部分中止、限制用户帐号的使用功能。</li>


            </ul>
          </li>
          <li>
            <h2>22.&nbsp;用户购买协议： </h2>
            <ul>
              <li>22.1
                VIP会员服务仅限于申请账号自行使用；VIP会员服务系网络商品和虚拟商品，采用先收费后服务的方式，会员费用是您所购买的会员服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质，VIP会员服务一经开通后不可转让或退款（如因VIP会员服务存在重大瑕疵导致您完全无法使用等我们违约情形、本协议另有约定、法律法规要求必须退款的或经我们判断后认为可以退款等除外）；
              </li>


            </ul>
          </li>
        </ul>
      </div>
      <div>
        <van-button icon="certificate" style="margin-bottom: 30px" type="danger" @click="show.privacy=false">我已阅读并同意以上服务条款</van-button>
      </div>
    </van-popup>
  </span>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      show: {
        privacy: false
      }
    }
  },
  methods: {
    showPrivacy() {
      this.$toast('请阅读以下内容')
      this.show.privacy = true
    }
  }
}
</script>

<style scoped>
.text {
  color: rgba(235, 59, 72, 1);
}

.main-content {
  color: #666666;
  padding: 20px;
}

.main-content h2 {
  font-size: 14px;
}

.main-content li {
  font-size: 12px;
  letter-spacing: 1px;
  text-align: left;
}

.main-content li h2 {
  text-align: left;
}

.main-content li li {
  margin-bottom: 10px;
}


</style>